import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "approved-flow" }
const _hoisted_2 = { class: "approved-flow__header" }
const _hoisted_3 = { class: "approved-flow__content" }
const _hoisted_4 = {
  key: 0,
  class: "approved-flow__header-title flex mt-10"
}
const _hoisted_5 = { class: "pl-4" }
const _hoisted_6 = { class: "approved-flow__box flex items-center w-full" }
const _hoisted_7 = { class: "approved-flow__vacation w-45-custom mr-20-custom" }
const _hoisted_8 = { class: "approved-flow__stamp w-45-custom" }
const _hoisted_9 = { class: "approved-flow__delete w-10-custom" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "approved-flow__add" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-plus text-xl" }, null, -1)
const _hoisted_13 = { class: "approved-flow__table" }
const _hoisted_14 = { class: "flex justify-center" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "flex items-baseline p-2 justify-center" }
const _hoisted_17 = { class: "approved-flow__role-check mr-2" }
const _hoisted_18 = {
  key: 0,
  class: "approved-flow__role-option ml-2"
}
const _hoisted_19 = {
  key: 1,
  class: "approved-flow__role-option ml-2"
}
const _hoisted_20 = { class: "flex items-center justify-center cursor-pointer" }
const _hoisted_21 = { class: "flex items-center justify-center" }
const _hoisted_22 = { class: "approved-flow__role-link" }
const _hoisted_23 = { class: "tooltiptext" }
const _hoisted_24 = { class: "approved-flow__footer flex justify-center items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Label = _resolveComponent("Label")
  const _component_Select = _resolveComponent("Select")
  const _component_Button = _resolveComponent("Button")
  const _component_RadioGroup = _resolveComponent("RadioGroup")
  const _component_Table = _resolveComponent("Table")
  const _component_GradationButton = _resolveComponent("GradationButton")

  return (_openBlock(), _createBlock("div", {
    class: "approved-setting-container ml-40 mr-40 mt-6",
    key: _ctx.keyEl
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("p", _hoisted_2, _toDisplayString(_ctx.t('approvedFlow.settingApplication')), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      (_ctx.isPersonalFlowScreen)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode(_component_Label, {
              "text-label": _ctx.t('approvedSetting.organization')
            }, null, 8, ["text-label"]),
            _createVNode("p", _hoisted_5, _toDisplayString(_ctx.nameOrg), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_Label, {
            "text-label": _ctx.t('dailyAttendanceHeaders.apply')
          }, null, 8, ["text-label"]),
          _createVNode(_component_Select, {
            placeholder: _ctx.t('placeholderSelect'),
            "options-select": _ctx.listAppFormDefines,
            itemText: 'text',
            modelValue: _ctx.app_form_define_id,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => (_ctx.app_form_define_id = $event)),
              _ctx.handleSelectAppFlow
            ]
          }, null, 8, ["placeholder", "options-select", "modelValue", "onUpdate:modelValue"])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_Label, {
            "text-label": _ctx.t('approvedFlow.approvedCopy')
          }, null, 8, ["text-label"]),
          _createVNode(_component_Select, {
            placeholder: _ctx.t('placeholderSelect'),
            "options-select": _ctx.listAppFormDefines,
            itemText: 'text',
            "onUpdate:modelValue": [
              _ctx.handleSelectAppFlowCopy,
              _cache[2] || (_cache[2] = ($event: any) => (_ctx.defineIdCopy = $event))
            ],
            modelValue: _ctx.defineIdCopy
          }, null, 8, ["placeholder", "options-select", "onUpdate:modelValue", "modelValue"])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_Button, {
            disabled: (!_ctx.isWorkFlowId && !_ctx.idDefine) || !_ctx.defineIdCopy,
            onClick: _ctx.copyAppFlowPersonal,
            label: _ctx.t('timeZone.buttonApply'),
            class: "approved-flow__btn whitespace-no-wrap"
          }, null, 8, ["disabled", "onClick", "label"])
        ])
      ])
    ]),
    (!!_ctx.app_form_define_id)
      ? (_openBlock(), _createBlock("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_Button, {
              class: [{ 'btn-disabled': _ctx.disabledAdd }, "approved-flow__button-style"],
              onClick: _ctx.handleAddApproved
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _createTextVNode(" " + _toDisplayString(_ctx.t('approvedFlow.btnAddApproved')), 1)
              ]),
              _: 1
            }, 8, ["class", "onClick"])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_Table, {
              data: _ctx.appBasicFlowSettingDetail,
              headers: _ctx.approvedSettingFlowHeaders,
              "show-select": false,
              visibleTable: ""
            }, {
              approved_flow_title: _withCtx(({ item, index }) => [
                _createVNode("div", _hoisted_14, [
                  (
                  _ctx.appBasicFlowSettingDetail[index - 1]?.approval_level !==
                  item?.approval_level
                )
                    ? (_openBlock(), _createBlock("div", _hoisted_15, _toDisplayString(`第${item.approval_level}承認者`), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              setting_register_flow: _withCtx(({ item, index }) => [
                _createVNode("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode(_component_RadioGroup, {
                      class: "mt-2",
                      optionsRadio: _ctx.AuthorityRoleOptions,
                      modelValue: item.setting_register_flow,
                      "onUpdate:modelValue": ($event: any) => (item.setting_register_flow = $event)
                    }, null, 8, ["optionsRadio", "modelValue", "onUpdate:modelValue"])
                  ]),
                  (item.setting_register_flow === 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_18, [
                        _createVNode(_component_Select, {
                          class: "f-w-select",
                          placeholder: _ctx.t('placeholderSelect'),
                          "options-select": _ctx.listApprovalEmployee,
                          itemText: 'text',
                          modelValue: item.approval_employee_id,
                          "onUpdate:modelValue": ($event: any) => (item.approval_employee_id = $event),
                          validated: _ctx.validated,
                          errors: _ctx.errors['approval_employee_id' + index],
                          "onUpdate:errors": ($event: any) => (_ctx.errors['approval_employee_id' + index] = $event),
                          required: ""
                        }, null, 8, ["placeholder", "options-select", "modelValue", "onUpdate:modelValue", "validated", "errors", "onUpdate:errors"])
                      ]))
                    : _createCommentVNode("", true),
                  (item.setting_register_flow === 1)
                    ? (_openBlock(), _createBlock("div", _hoisted_19, [
                        _createVNode(_component_Select, {
                          class: "f-w-select",
                          placeholder: _ctx.t('placeholderSelect'),
                          "options-select": _ctx.listApprovalRole,
                          itemText: 'text',
                          modelValue: item.approval_role_id,
                          "onUpdate:modelValue": ($event: any) => (item.approval_role_id = $event),
                          validated: _ctx.validated,
                          errors: _ctx.errors['approval_role_id' + index],
                          "onUpdate:errors": ($event: any) => (_ctx.errors['approval_role_id' + index] = $event),
                          required: ""
                        }, null, 8, ["placeholder", "options-select", "modelValue", "onUpdate:modelValue", "validated", "errors", "onUpdate:errors"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              plus: _withCtx(({ item, index }) => [
                _createVNode("div", _hoisted_20, [
                  (
                  item.approval_level !==
                  _ctx.appBasicFlowSettingDetail[index + 1]?.approval_level
                )
                    ? (_openBlock(), _createBlock("div", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.handleAddApproveSameLevel(item, index))
                      }, [
                        _createVNode("span", {
                          class: [{
                    'text-grey-999':
                      (item.setting_register_flow === 0 &&
                        !item.approval_employee_id) ||
                      (item.setting_register_flow === 1 &&
                        !item.approval_role_id),
                    'cursor-not-allowed':
                      (item.setting_register_flow === 0 &&
                        !item.approval_employee_id) ||
                      (item.setting_register_flow === 1 &&
                        !item.approval_role_id),
                  }, "cp-icon-plus font-size-24 text-blue-600"]
                        }, null, 2)
                      ], 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              delete: _withCtx(({ index }) => [
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _createVNode("div", {
                      class: "icon-tooltip cursor-pointer",
                      onClick: ($event: any) => (_ctx.handleDeleteApprove(index))
                    }, [
                      _createVNode("span", _hoisted_23, _toDisplayString(_ctx.t('actionDelete')), 1),
                      _createVNode("span", {
                        class: [{
                      'cursor-not-allowed':
                        _ctx.appBasicFlowSettingDetail &&
                        _ctx.appBasicFlowSettingDetail.length === 1,
                      'hover:text-blue-600':
                        _ctx.appBasicFlowSettingDetail &&
                        _ctx.appBasicFlowSettingDetail.length > 1,
                    }, "cp-icon-trash text-2xl text-grey-999"]
                      }, null, 2)
                    ], 8, ["onClick"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["data", "headers"])
          ]),
          _createVNode("div", _hoisted_24, [
            _createVNode(_component_GradationButton, {
              disabled: _ctx.isDisableButtonPersonFlow,
              onClick: _ctx.handleRegister,
              class: "approved-flow__register"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('approvedFlow.toRegister')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            _createVNode(_component_Button, {
              class: "approved-flow__back",
              onClick: _ctx.backToApprovedSetting
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('approvedFlow.backToTheList')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}